module.exports = __webpack_public_path__ + "static/media/logo.9644f536.svg";